import { observer } from 'mobx-react';
import LicenseExpiredModal from './LicenseExpiredModal';
import InviteParticipantStore from '../../Store';
import { SelectParticipantsState } from '../../Types';
import { Link } from '../../../../../../../../Resource/Types';
import { whenLte } from '@execonline-inc/numbers';
import { just } from 'maybeasy';
import ReadyModal from '../../RenderInviteParticipantsModal/ReadyModal';

export interface Props {
  store: InviteParticipantStore;
  links: ReadonlyArray<Link>;
  state: SelectParticipantsState;
}

function ReadyModalContent({ store, links, state }: Props) {
  return just(state.daysUntilRenewal)
    .andThen(whenLte(0))
    .map(() => <LicenseExpiredModal close={store.modalStore.close} title={state.publicName} />)
    .getOrElse(() => <ReadyModal state={state} links={links} store={store} />);
}

export default observer(ReadyModalContent);
